

<template>
  <div
    v-if="!item.meta || !item.meta.hidden"
    :class="[
      isCollapse ? `simple-mode ${routecurrent.matched[0].path==basePath?'simple-mode1':''}`: 'full-mode',
      {'first-level': isFirstLevel}, {'setmueuicon':!isCollapse}
    ]"
  >
    <template
      v-if="!alwaysShowRootMenu && theOnlyOneChild && !theOnlyOneChild.children"
    >
      <SidebarItemLink
        v-if="theOnlyOneChild.meta"
        :to="resolvePath(theOnlyOneChild.path)"
      >
        <el-menu-item
          :index="resolvePath(theOnlyOneChild.path)"
          :class="{'submenu-title-noDropdown': isFirstLevel,'wrap_text': wrap_textFlag}"
        >
          <img
            class="navIcon"
            :src="totalImg[routecurrent.matched[0].path==basePath?theOnlyOneChild.meta.icon1:theOnlyOneChild.meta.icon2]"
            alt=""
            aria-hidden="true"
            width="20"
          >
          <!-- {{routecurrent}} -->
          <!-- {{basePath}} -->
          <span v-if="theOnlyOneChild.meta.title">{{
            t("route." + theOnlyOneChild.meta.title)
          }}</span>
        </el-menu-item>
      </SidebarItemLink>
    </template>
    <el-submenu
      v-else
      :index="resolvePath(item.path)"
    >
      <!-- popper-append-to-body -->
      <template #title>
      <div :style="{color:routecurrent.matched[0].path==basePath?'#1890FF':''}" class="menudiv">
          <img
          class="navIcon"
          :src="totalImg[routecurrent.matched[0].path==basePath?item.meta.icon1:item.meta.icon2]"
          alt=""
          aria-hidden="true"
          width="20"
        >
        <!-- {{routecurrent.matched[0].path==basePath?totalImg[item.meta.icon]:''}} -->
        <span v-if="item.meta && item.meta.title">{{
          t("route." + item.meta.title)
        }}</span>
      </div>
      </template>
      <template v-if="item.children">
        <sidebar-item
          v-for="child in item.children"
          :key="child.path"
          :item="child"
          :is-collapse="isCollapse"
          :is-first-level="false"
          :base-path="resolvePath(child.path)"
          class="nest-menu"
        />
      </template>
    </el-submenu>
  </div>
</template>

<script lang="ts">
import path from 'path'
import { computed, defineComponent, PropType, toRefs, onMounted } from 'vue'
import { RouteRecordRaw,useRoute } from 'vue-router'
import { isExternal } from '@/utils/validate'
import SidebarItemLink from './SidebarItemLink.vue'
import { useI18n } from 'vue-i18n'
import { totalImg } from '@/utils/robot' 
import { getLanguage } from "@/utils/cookies";
export default defineComponent({
  props: {
    item: {
      type: Object as PropType<RouteRecordRaw>,
      required: true
    },
    isCollapse: {
      type: Boolean,
      required: false
    },
    isFirstLevel: {
      type: Boolean,
      required: true
    },
    basePath: {
      type: String,
      required: true
    }
  },
  components: {
    SidebarItemLink
  },
  setup(props) {

    const routecurrent = useRoute()
    const state = {
      wrap_textFlag: false,
      totalImg: totalImg()
    }
    const get_language = () => {
      let language = getLanguage()
      if(language == 'ja'){
        state.wrap_textFlag = false
      }else {
        state.wrap_textFlag = true
      }
    }
    get_language()
    const alwaysShowRootMenu = computed(() => {
      if (props.item.meta && props.item.meta.alwaysShow) {
        return true
      } else {
        return false
      }
    })

    const showingChildNumber = computed(() => {
      if (props.item.children) {
        const showingChildren = props.item.children.filter((item) => {
          if (item.meta && item.meta.hidden) {
            return false
          } else {
            return true
          }
        })
        return showingChildren.length
      }
      return 0
    })

    const theOnlyOneChild = computed(() => {
      if (showingChildNumber.value > 1) {
        return null
      }
      if (props.item.children) {
        for (const child of props.item.children) {
          if (!child.meta || !child.meta.hidden) {
            return child
          }
        }
      }
      // If there is no children, return itself with path removed,
      // because this.basePath already conatins item's path information
      return { ...props.item, path: '' }
    })

    const resolvePath = (routePath: string) => {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(props.basePath)) {
        return props.basePath
      }
      return path.resolve(props.basePath, routePath)
    }
    const { t } = useI18n()

    return {
      ...toRefs(state),
      t,
      get_language,
      alwaysShowRootMenu,
      showingChildNumber,
      theOnlyOneChild,
      resolvePath,
      routecurrent
    }
  }
})
</script>

<style lang="scss" scoped>
.is-active {
  color: #1890FF !important;
  background: #E6F8FF!important;
}
.full-mode {
  .nest-menu .el-submenu > .el-submenu__title,
  .el-submenu .el-menu-item {
    min-width: $sideBarWidth !important;
    #background-color: $subMenuBg !important;

    &:hover {
      background-color: $subMenuHover !important;
    }
  }
  .el-menu-item{
    &>span{
      display: inline-block;
      padding-left: 5px;
    }
  }
  .el-submenu {
    overflow: hidden;

    & > .el-submenu__title {
      .el-submenu__icon-arrow{
        display: none;
      }

      & > span {
             padding-left: 5px;

      }
    }
  }
}

.simple-mode {
  &.first-level {
    .submenu-title-noDropdown {
      padding: 0 !important;
      position: relative;

      .el-tooltip {
        padding: 0 !important;
      }
    }

    .el-submenu {
      overflow: hidden;

      & > .el-submenu__title {
        padding: 0px !important;
        .el-submenu__icon-arrow{
          display: none;
        }

        & > span {
          visibility: hidden;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
svg, .navIcon {
  margin-right: 24px;
  font-size: 18px;
}

.simple-mode {
  svg, .navIcon {
    margin-left: 16px;
  }
}
</style>

<style lang="scss">
.wrap_text span{
  white-space: normal;
    word-wrap: break-word ;
    line-height: normal;
    display: inline-block;
}

.setmueuicon{
 .el-submenu__icon-arrow{
  display: none;
 }
}
.simple-mode1{
  .el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow{
  color: #1890FF;
}
}
</style>